import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SiteContentCtx = createContext(null);

export const SiteContentProvider = ({ children }) => {
  const [cms, setCms] = useState({ settings: {}, page: {}, team: [], portfolio: [], jobs: [], blog: [], loaded: false });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const [site, team, portfolio, jobs, blog] = await Promise.all([
          axios.get(`${API}/site-content`).catch(() => ({ data: { settings: {}, page: {} } })),
          axios.get(`${API}/team`).catch(() => ({ data: [] })),
          axios.get(`${API}/portfolio`).catch(() => ({ data: [] })),
          axios.get(`${API}/jobs`).catch(() => ({ data: [] })),
          axios.get(`${API}/blog`).catch(() => ({ data: [] })),
        ]);
        if (cancelled) return;
        setCms({
          settings: site.data.settings || {},
          page: site.data.page || {},
          team: team.data || [],
          portfolio: portfolio.data || [],
          jobs: jobs.data || [],
          blog: blog.data || [],
          loaded: true,
        });
      } catch {
        setCms((c) => ({ ...c, loaded: true }));
      }
    })();
    return () => { cancelled = true; };
  }, []);

  // page-content helpers
  const value = useMemo(() => {
    const pg = (key, fallback = "") => {
      const v = cms.page?.[key];
      return v == null || v === "" ? fallback : v;
    };
    const pgList = (key, fallback = []) => {
      const raw = cms.page?.[key];
      if (raw == null || raw === "") return fallback;
      try {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : fallback;
      } catch { return fallback; }
    };
    return { ...cms, pg, pgList };
  }, [cms]);

  return <SiteContentCtx.Provider value={value}>{children}</SiteContentCtx.Provider>;
};

export const useSiteContent = () => useContext(SiteContentCtx) || {
  settings: {}, page: {}, team: [], portfolio: [], jobs: [], blog: [], loaded: false,
  pg: (_, f = "") => f, pgList: (_, f = []) => f,
};

// Helper: get image URL for a backend image_id
export const cmsImage = (imageId) => imageId ? `${API}/images/${imageId}` : null;
